import React from 'react';
import { Button, DialogActions, DialogTitle } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import {
    reconnectSubscription,
    unsubscribeAll
} from '@/component/chatThread/handler/SubsciptionHandler';

export const ChatPostReconnectDialog = (props) => {

    //btn close
    const onClickBtnClose = (event, reason) => {
        document.querySelector(".close-reconnect-subscription-button").click();
        
        if (event && reason === "backdropClick") {
            return false;
        }
        // close all connect socket
        unsubscribeAll(props.panelId);

        // close reconnect dialog
        props.setIsShowReconnectDialog(false);
        // props.history.push(Constant.LIST_TICKET_ROUTER);
    };

    // btn reconnect
    const onClickBtnReconnect = () => {
        // init subscription handler
        let chatThreadAll = {};
        chatThreadAll.customerReferenceThread = props.customerReferenceThread;
        chatThreadAll.customerThread = props.customerThread;
        chatThreadAll.internalThread = props.internalThread;
        chatThreadAll.escalationThread = props.escalationThread;
        chatThreadAll.delegateThread = props.delegateThread;

        let args = {
            API: props?.API,
            msgContentList: props.msgContentList,
            setMsgContentList: props.setMsgContentList,
            statusDeleteMsgList: props.statusDeleteMsgList,
            setStatusDeleteMsgList: props.setStatusDeleteMsgList,
            editedMsgList: props.editedMsgList,
            setEditedMsgList: props.setEditedMsgList,
            footprintDetailList: props.footprintDetailList,
            setFootprintDetailList: props.setFootprintDetailList,
            chatPostAllList: props.chatPostAllList,
            isShowAllChatPost: props.isShowAllChatPost,
            // chatThreadSelected: props.chatThreadSelected,
            setChatPostAllList: props.setChatPostAllList,
            setIsShowReconnectDialog: props.setIsShowReconnectDialog,
            setChatPostUpdate: props.setChatPostUpdate,
            isShowReconnectDialog: false,

            setIsDisableUserListDelegateMsg: props.setIsDisableUserListDelegateMsg,
            setSubsciptionChatPostUpdateResponse: props.setSubsciptionChatPostUpdateResponse,
            panelId: props.panelId,
            setUserChatList: props.setUserChatList,
            projectInuseDetail: props.projectInuseDetail,
            // chat thread
            chatThreadAll
        };

        // reconnect socket
        reconnectSubscription(args);

        // close reconnect dialog
        props.setIsShowReconnectDialog(false);

        document.querySelector(".reconnect-subscription-button").click();
    };

    return (
        <Dialog
            open={props.isShowReconnectDialog}
            onClose={(event, reason) => onClickBtnClose(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
            // disableBackdropClick="true" 
        >
            <DialogTitle className="titleHeader">
                <h2 className="title">{I18n.get('COMLB001')}</h2>
            </DialogTitle>
            <DialogContent>
                <div className="confirm-dialog-content">
                    {I18n.get('COMMSG002')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action close-reconnect-subscription-button">
                {/* btn close */}
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={onClickBtnClose}>
                    {I18n.get('COMBTN006')}
                </Button>
                {/* btn reconnect */}
                <Button
                    className="confirm-dialog-button reconnect-subscription-button"
                    variant="contained"
                    color="primary"
                    onClick={onClickBtnReconnect}>
                    {I18n.get('COMBTN005')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};